import React, { useState, useEffect } from 'react';
import axios from "axios";
import Table from "react-bootstrap/Table";
import Container from "react-bootstrap/Container";
import Button from 'react-bootstrap/Button';
import DetalleProductos from '../Componentes/Productos/TablaProductos';
import AgregarDescripcion from '../Componentes/Productos/AgregarDescripcion';

export default function TablaProductos() {
    const obtenerProductosURL = "https://invio.datachile.site/Web/Productos/ObtenerProductos.php";
    const [productos, setProductos] = useState([]);
    const [empresa_idEmpresa, setEmpresaIdEmpresa] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [selectedDescripcion, setSelectedDescripcion] = useState(null);
    const [productoSeleccionado, setProductoSeleccionado] = useState(null);

    useEffect(() => {
        // Obtener empresa_idEmpresa del localStorage al cargar el componente
        const userData = JSON.parse(localStorage.getItem('usuario'));
        if (userData && userData.empresa_idEmpresa) {
            setEmpresaIdEmpresa(userData.empresa_idEmpresa);
            console.log('empresa_idEmpresa:', userData.empresa_idEmpresa);
            getProductos(userData.empresa_idEmpresa); // Llamar a getProductos con empresa_idEmpresa
        }
    }, []);

    // Función para obtener todos los productos por empresa_idEmpresa
    const getProductos = async (empresaId) => {
        try {
            const response = await axios.post(obtenerProductosURL, { empresa_idEmpresa: empresaId });
            setProductos(response.data);
        } catch (error) {
            console.error('Error al obtener productos:', error);
        }
    };

    // Función para obtener un producto específico por idDescripcion
    const obtenerProductoPorIdDescripcion = async (idDescripcion) => {
        try {
            const response = await axios.post(obtenerProductosURL, { empresa_idEmpresa });
            const productos = response.data;

            // Buscar el producto que coincida con idDescripcion
            const productoEncontrado = productos.find(producto => producto.idDescripcion === idDescripcion);
            if (productoEncontrado) {
                setProductoSeleccionado(productoEncontrado);
                setShowModal(true); // Mostrar el modal después de encontrar el producto
            } else {
                console.warn('No se encontró ningún producto con el id de descripción proporcionado.');
            }
        } catch (error) {
            console.error('Error al obtener el producto por id de descripción:', error);
        }
    };

    const handleShowModal = (idDescripcion) => {
        setSelectedDescripcion(idDescripcion);
        obtenerProductoPorIdDescripcion(idDescripcion); // Llamar función para obtener el producto por idDescripcion
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setSelectedDescripcion(null);
        setProductoSeleccionado(null); // Limpiar el producto seleccionado al cerrar el modal
    };

    return (
        <Container maxWidth="sm">
            <h2 className="my-4 text-center" style={{ fontWeight: 'bold', color: '#007bff' }}>Gestión de Productos</h2>
            <div className="table-responsive">
                <AgregarDescripcion />
                <Table striped bordered hover size="sm" className="table-sm">
                    <thead>
                        <tr>
                            <th scope="col">Imagen</th>
                            <th scope="col">Descripción</th>
                            <th scope="col">Código Genérico</th>
                            <th scope="col">Cantidad de Productos</th>
                            <th scope="col">Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {productos.length > 0 ? (
                            productos.map((producto) => (
                                <tr key={producto.codigo}>
                                    <td className='centrar'>
                                        <img src={producto.foto_generica} alt="Imagen genérica" style={{ maxWidth: "50px", height: "auto" }} />
                                    </td>
                                    <td className='centrar'>{producto.descripcion}</td>
                                    <td className='centrar'>{producto.codigo}</td>
                                    <td className='centrar'>{producto.cantidad_productos}</td>
                                    <td style={{ display: 'flex', gap: '10px' }}>
                                        <Button variant="primary" size="sm" onClick={() => handleShowModal(producto.idDescripcion)}>
                                            Ver
                                        </Button>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="5" className="text-center">No hay productos disponibles</td>
                            </tr>
                        )}
                    </tbody>
                </Table>
            </div>
            {productoSeleccionado && (
                <DetalleProductos
                    show={showModal}
                    handleClose={handleCloseModal}
                    producto={productoSeleccionado}
                />
            )}
        </Container>
    );
}
